import { useMutation } from "@tanstack/react-query";
import TenantAPI from "../../api/TenantAPI";
import { useSetAtom } from "jotai";
import { setSchemaAtom } from "../../../atoms/GlobalAtoms";
import { callFunctionIfExists } from "../../../utils/GeneralUtils";
import { AppConfirm } from "../../../utils/PopupUtil";

interface Props {
  moduleAPIName: string;
  dtID: string;
  onSuccess?: () => void;
  onError?: () => void;
}

const useDeleteDataTransforms = () => {
  const setSchema = useSetAtom(setSchemaAtom);

  const mutation = useMutation({
    mutationFn: async ({ moduleAPIName, dtID }: Props) => {
      const confirm = await AppConfirm({
        title: "Confirm Data Transform Deletion",
        text: `Are you sure you want to delete this data transform?`,
      });
      if (!confirm.isConfirmed) throw { message: "User cancelled" };

      return await TenantAPI.removeDataTransforms(moduleAPIName, dtID);
    },
    onSuccess: (data, { onSuccess }) => {
      const newSchema = data.data.data.schema;
      setSchema(newSchema);
      callFunctionIfExists(onSuccess, newSchema);
    },
  });

  return {
    deleteDataTransforms: mutation.mutate,
    loading: mutation.isPending,
    error: mutation.error,
  };
};

export default useDeleteDataTransforms;
